module.exports = __webpack_public_path__ + "img/businessintelligence.9536118d.png";